/**
 * Created by andreyna on 2/23/2017.
 */
const PENDING_ACTIONS = {
    EXTERNAL_LINK: 'external_link',
    GAME: 'game'
};

export {PENDING_ACTIONS};